import locale from './menuLanguage';
export default {
    // menu: [{
    //     'mainTitle': locale.logisticsMenu.logisCurrentPosition,
    //     'link': '/admin.html#/',
    //     'type': 'Group', // 没有子菜单
    //     'alias': 'adminService',
    //     'id': 11
    // }],
    index: [{
        'mainTitle': locale.logisticsMenu.logisCurrentPosition, // 当前位置
        'link': '/index.html#/',
        'type': 'Group', // 没有子菜单
        'alias': 'register',
        'id': 11
        },
        {
            'mainTitle': locale.logisticsMenu.register, // 注册
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 12,
            'pid': 11
        },
        {
            'mainTitle': locale.logisticsMenu.findpassword,// 找回密碼
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 13,
            'pid': 11
        }
    ]
};


// WEBPACK FOOTER //
// ./src/api/indexAdmin.js